import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { DialogModule } from 'primeng/dialog';
import { CardModule } from 'primeng/card';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidebarComponent } from './layouts/sidebar/sidebar.component';
import { HeaderComponent } from './layouts/header/header.component';
import { FooterComponent } from './layouts/footer/footer.component';
import { ContentComponent } from './layouts/content/content.component';
import { LoginComponent } from './layouts/components/login/login.component';
import { MessageService } from 'primeng/api';
import { ToasterService } from './services/toaster.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import {
  authInterceptorProviders,
  AuthInterceptor,
} from './helpers/auth.interceptor';
import { AttendanceModule } from './layouts/components/attendance/attendance.module';
import { MasterComponent } from './layouts/components/admin/policy-allowance-benefits/master.component';
import { NgxEditorModule } from 'ngx-editor';
import { TableModule } from 'primeng/table';
import {
  NgbPaginationModule,
  NgbTypeaheadModule,
} from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { CommonModule, DatePipe } from '@angular/common';
import { CalendarModule } from 'primeng/calendar';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  HttpClient,
} from '@angular/common/http';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from './shared.module';
import { StepperModule } from 'primeng/stepper';
import { ButtonModule } from 'primeng/button';

import { NgIdleModule } from '@ng-idle/core';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

import { DragDropModule } from '@angular/cdk/drag-drop';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ChangePasswordComponent } from './layouts/components/change-password/change-password.component';
import { CustomWidgetsComponent } from './layouts/custom-widgets/custom-widgets.component';
import { LoaderInterceptor } from './helpers/loader.interceptor';
import { LoaderComponent } from './layouts/loader/loader/loader.component';
// import { AttendancePunchWidgetComponent } from './layouts/widget-components/attendance-punch-widget/attendance-punch-widget.component';
// import { BirthdayWidgetComponent } from './layouts/widget-components/birthday-widget/birthday-widget.component';
// import { CompanypolicyWidgetComponent } from './layouts/widget-components/companypolicy-widget/companypolicy-widget.component';
// import { NoticeboardWidgetComponent } from './layouts/widget-components/noticeboard-widget/noticeboard-widget.component';
// import { PendingstatusWidgetComponent } from './layouts/widget-components/pendingstatus-widget/pendingstatus-widget.component';
// import { PendingworkflowWidgetComponent } from './layouts/widget-components/pendingworkflow-widget/pendingworkflow-widget.component';
// import { OngoingTrainingsWidgetComponent } from './layouts/widget-components/ongoing-trainings-widget/ongoing-trainings-widget.component';
// import { PersonalCalendarWidgetComponent } from './layouts/widget-components/personal-calendar-widget/personal-calendar-widget.component';
// import { LeavesWidgetComponent } from './layouts/widget-components/leaves-widget/leaves-widget.component';
// import { LoansWidgetComponent } from './layouts/widget-components/loans-widget/loans-widget.component';
// import { EmployeeOfTheMonthWidgetComponent } from './layouts/widget-components/employee-of-the-month-widget/employee-of-the-month-widget.component';
// import { ProfileWidgetComponent } from './layouts/widget-components/profile-widget/profile-widget.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { AuditComponent } from './layouts/audit/audit/audit.component';
import { SystemUserLogComponent } from './layouts/audit/system-user-log/system-user-log.component';
import { FormlyFieldFileComponent } from './formly-field-file.component';
import { TextEditorComponent } from './text-editor/text-editor.component';
import { QuillModule } from 'ngx-quill';
import { ComplaintsComponent } from './layouts/components/employee/complaints/complaints.component';
import { OtpVerifyComponent } from './layouts/components/otp-verify/otp-verify.component';
import { GaSetupComponent } from './layouts/components/otp-verify/ga-setup/ga-setup.component';
import { GaVerifyComponent } from './layouts/components/otp-verify/ga-verify/ga-verify.component';
import { GaOtpComponent } from './layouts/components/otp-verify/ga-otp/ga-otp.component';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';
import { ApprovalComponent } from './pages/approval/approval.component';
import { TableexportModule } from './layouts/components/admin/export-import/tableexport.module';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    HeaderComponent,
    FooterComponent,
    ContentComponent,
    LoginComponent,
    MasterComponent,
    ChangePasswordComponent,
    CustomWidgetsComponent,
    AuditComponent,
    SystemUserLogComponent,
    OtpVerifyComponent,
    GaSetupComponent,
    GaVerifyComponent,
    GaOtpComponent,
    AccessDeniedComponent,
    ApprovalComponent,
    // ComplaintsComponent,
    // LoaderComponent,
    // AttendancePunchWidgetComponent,
    // ProfileWidgetComponent
    // BirthdayWidgetComponent,
    // CompanypolicyWidgetComponent,
    // NoticeboardWidgetComponent,
    // PendingstatusWidgetComponent,
    // PendingworkflowWidgetComponent,
    // OngoingTrainingsWidgetComponent,
    // PersonalCalendarWidgetComponent,
    // LeavesWidgetComponent,
    // LoansWidgetComponent,
    // EmployeeOfTheMonthWidgetComponent
  ],
  imports: [
    CardModule,
    DialogModule,
    CommonModule,
    QuillModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaterialTimepickerModule,
    FormlyBootstrapModule,
    FormlyModule.forRoot({
      types: [
        { name: 'file', component: FormlyFieldFileComponent, wrappers: ['form-field'] }
      ]
    }),

    AppRoutingModule,
    NgxEditorModule,
    TableModule,
    NgbPaginationModule,
    NgbTypeaheadModule,
    AttendanceModule,
    OrganizationChartModule,
    BrowserAnimationsModule,
    CalendarModule,
    NgApexchartsModule,
    NgSelectModule,
    SharedModule,
    StepperModule,
    MultiSelectModule,
    ButtonModule,
    NgIdleModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    DragDropModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    TableexportModule,
  ],

  providers: [
    MessageService,
    ToasterService,
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    authInterceptorProviders,


  ],
  bootstrap: [AppComponent],
})
export class AppModule { }


